import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { showLoader } from "../../redux/actions/action_loader";
import Button from "@material-ui/core/Button";
import "./GenerateOtpOld.css";
import Error from "./../Error/Error";
// import axios from "axios";
import { getApiData } from "../../api/api";
import Snackbar from "../Snackbar/Snackbar";
import {
  physicalJourneyText,
  regularAlertsDiscalimer,
  CisDisclaimerTextForGenOtp,
  CisIsNpsDisclaimerText,
  CisJourneyText,

} from "../../utils/disclaimerText";
import { DECLRATION_IDS, GENERATE_OTP_ATTEMPTS_ALLOWED, YES } from "../../utils/constants";
import { withTranslation } from "react-i18next";
import HeadStepper from "../HeadStepper/HeadStepper";
import {
  hybridPosvSteps,
  isNpsSteps,
  photoVerificationSteps,
  QCSteps,
} from "../../utils/stepperStep";
import AxiosRequest from "../../utils/axios";
import cryptoJs from "crypto-js";
import OtpOld from "./OtpOld/OtpOld";
import ClubbedOtp from "../ClubbedOtp/ClubbedOtp";
import GoGreenSection from "../POSV_New_Ui/GoGreenSection/GoGreenSection";
import MergeChunkErrorDialog from "../POSV_New_Ui/MergeChunkErrorDialog/MergeChunkErrorDialog";
import Axios from "axios";
import { CAPS_N, CAPS_Y } from "../../utils/constants";
import { getOTPDeclarationFromStorage } from "../../utils/handleData";
import { getUserLang } from "../../utils/handleVoiceAndLang";
import { getConfigFromStroage } from "../../utils/getUrlsFromAws";

const axios = new AxiosRequest().getClient();

class GenerateOtpOld extends Component {
  constructor() {
    super();
    this.state = {
      generatingOtp: false,
      submitting: false,
      disableSubmitButton: true,
      disableGenerateOtpButton: false,
      otp: undefined,
      otpButtonText: "Generate OTP",
      showCallButton: false,
      disableCallButton: true,
      enableOtpButton: "Y",
      enableOtpOnCallButton: "Y",
      callAttemptsSuccess: 0,
      generateOtpAttempts: 0,
      generateOtpTime: 60,
      callOtpTime: 60,
      showGenerateOtpTime: false,
      showCallTime: false,
      showSnackbar: false,
      snackbarMsgType: "",
      snackbarMsg: "",
      displayMessage: "Please click on Generate OTP to proceed",
      checkboxValue: localStorage.getItem("journeyBy") == "P" ? true : false,
      channelName: localStorage.getItem("channelName"),
      showOTPPage: localStorage.getItem("restrictOTP"),
      errorMsg: localStorage.getItem("restrictOTPMsg"),
      ulipStatus: localStorage.getItem("ulipStatus"),
      journeyBy: localStorage.getItem("journeyBy"),
      isNps: localStorage.getItem("isNps"),
      isVideoPosv: localStorage.getItem("isVideoPosv"),
      twoStep: localStorage.getItem("twoStep"),
      submissionRestricted: "",
      businessMsg: "",
      attemptErrorMsg: "",
      physicalJourneyEnabled: localStorage.getItem("physicalJourneyEnabled"),
      declarationObj: {},
      posvRefNumber: localStorage.getItem("posvRefNumber"),
      showClubbedOtpPage:
        localStorage.getItem("journeyBy") == "P" ? true : false,
      isWipClubbed: localStorage.getItem("isWipClubbed"),
      isPanAadharLinked: localStorage.getItem("isPanAadharLinked"),
      customerConsentAfyp: localStorage.getItem("customerConsentAfyp"),
      aadharCheckbox: false,
      goGreenFlag: 'Y',
      showGoGreenSection: localStorage.getItem("showGoGreenSection"),
      getAlertsCheckbox: CAPS_Y,
      cis: localStorage.getItem("cis"),
      cisConsentOnOtp: "",
      isPanLinked: localStorage.getItem("isPanLinked"),
      isUpfrontPaymentConsentChecked: false,
      isUpfrontPaymentConsentApplicable: localStorage.getItem("upfrontPaymentConsent") === CAPS_Y
    };
  }

  componentDidMount() {
    this.props.showLoader(false);
    window.scrollTo(0, 0);
    document.addEventListener("keyup", this.inputFunction);
    let declarationObj = this.getOTPDeclaration();
    this.setState({ declarationObj });
  }

  getLanguage = () => {
    return localStorage.getItem("LanguageSelected");
  };

  getOTPDeclaration = () => {
    const { channelName, isNps, physicalJourneyEnabled, journeyBy, cis, cisConsentOnOtp } =
      this.state;
    const {
      CIS_JOURNEY_TEXT, PHYSICAL_JOURNEY_TEXT,
      CIS_DISCLAIMER_TEXT_FOR_GEN_OTP,
      CIS_IS_NPS_DISCLAIMER_TEXT,
      IS_NPS_DISCLAIMER_TEXT, DISCLAIMER_TEXT_FOR_GEN_OTP
    } = DECLRATION_IDS;
    let declarationObj = {
      showDeclaration: true,
      declaration: "",
    };
    if (physicalJourneyEnabled === "yes") {
      const decId = (cis === YES) ? CIS_JOURNEY_TEXT : PHYSICAL_JOURNEY_TEXT;
      declarationObj.declaration = getOTPDeclarationFromStorage(decId)[getUserLang()];
      this.setState({ cisConsentOnOtp: getOTPDeclarationFromStorage(decId) });
      return declarationObj;
    }

    if (channelName === "x" || journeyBy == "P") {
      declarationObj.declaration = "";
      declarationObj.showDeclaration = false;
      return declarationObj;
    }
    if (channelName !== "x") {
      if (isNps === "Y") {
        const decId = (cis === YES) ? CIS_IS_NPS_DISCLAIMER_TEXT : IS_NPS_DISCLAIMER_TEXT;
        declarationObj.declaration = getOTPDeclarationFromStorage(decId)[getUserLang()];
        this.setState({ cisConsentOnOtp: getOTPDeclarationFromStorage(decId) });
      }
      // else if (ulipStatus === "Yes") {
      //   declarationObj.declaration = ulipDisclaimerText
      // }
      else {
        const decId = (cis === YES) ? CIS_DISCLAIMER_TEXT_FOR_GEN_OTP : DISCLAIMER_TEXT_FOR_GEN_OTP;
        declarationObj.declaration = getOTPDeclarationFromStorage(decId)[getUserLang()];
        this.setState({ cisConsentOnOtp: getOTPDeclarationFromStorage(decId) });
      }
      return declarationObj;
    }
  };

  componentWillUnmount() {
    document.removeEventListener("keyup", this.inputFunction);
  }

  inputFunction = () => {
    const [i0, i1, i2, i3, i4, i5] = document.querySelectorAll(".input_otp");
    if (i0.value && i1.value && i2.value && i3.value && i4.value && i5.value) {
      this.setState({ disableSubmitButton: false });
    } else {
      this.setState({ disableSubmitButton: true });
    }
  };

  getEncryptedData = () => {
    const { posvRefNumber } = this.state;
    let urlsData = getConfigFromStroage();
    const defaultEncryptionKey = urlsData["defaultEncryptionKey"];
    let key = defaultEncryptionKey
    let encryptedBase64Key = btoa(key);
    let parsedBase64Key = cryptoJs.enc.Base64.parse(encryptedBase64Key);
    let encryptedData = "";

    let posvrefnum = posvRefNumber;
    encryptedData = cryptoJs.AES.encrypt(posvrefnum, parsedBase64Key, {
      mode: cryptoJs.mode.ECB,
      padding: cryptoJs.pad.Pkcs7,
    });
    return encryptedData.toString();
  };

  generateOtp = (type) => {
    this.setState({ generatingOtp: true }, async () => {
      let { url, body } = getApiData("getOtp");

      body = JSON.parse(JSON.stringify(body));
      let generateOtpinterval;
      body.request.payload.lang = this.getLanguage();
      body.request.payload.posvRefNumber = this.getEncryptedData();
      body.request.payload.clubbeOtpDetails = this.state.clubbeOtpDetails;
      // }
      if (type !== "call") {
        console.log(
          "this.state.callAttemptsSuccess",
          this.state.callAttemptsSuccess
        );
        this.setState({
          showGenerateOtpTime: true,
          disableGenerateOtpButton: true,
          generateOtpAttempts: ++this.state.generateOtpAttempts,
          disableCallButton: true,
        });

        generateOtpinterval = setInterval(() => {
          this.setState({ generateOtpTime: --this.state.generateOtpTime });
          if (this.state.generateOtpTime === 0) {
            clearInterval(generateOtpinterval);
            if (this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED) {
              this.setState({
                disableGenerateOtpButton: true,
                showCallButton: true,
              });
            } else {
              this.setState({ disableGenerateOtpButton: false });
            }

            if (this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED) {
              this.setState({
                attemptErrorMsg:
                  "You have exceeded the OTP on SMS and Email attempts, please click Get OTP on call",
              });
            }
            this.setState({
              showGenerateOtpTime: false,
              generateOtpTime: 60,
              // showCallButton: true,
              disableCallButton: false,
            });
            if (this.state.callAttemptsSuccess >= 1) {
              this.setState({ disableCallButton: true });
            }
          }
        }, 1000);
      }

      if (type === "call") {
        console.log(
          "this.state.generateOtpAttempts",
          this.state.generateOtpAttempts
        );
        if (!this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED) {
          this.setState({ disableGenerateOtpButton: false });
        }
        this.setState({ showCallTime: false, disableCallButton: true });
        body.request.payload.onCallOTP = "Yes";
        if (this.state.callOtpTime === 0) {
          if (
            this.state.enableOtpOnCallButton === "N" &&
            this.state.callAttemptsSuccess >= 1
          ) {
            this.setState({ disableCallButton: true });
          } else {
            this.setState({ disableCallButton: false });
          }
          this.setState({
            showCallTime: false,
          });
        }
      }

      try {
        this.props.showLoader(true);
        const response = await axios.post(url, body);
        let { enableOtpButton, enableOtpOnCallButton } =
          response.data.response.payload;
        this.setState({
          displayMessage: response.data.response.payload.levelMessage
            ? response.data.response.payload.levelMessage
            : "Please click on Generate OTP to proceed",
          enableOtpButton,
          enableOtpOnCallButton,
        });
        if (type === "call") {
          this.setState(
            { callAttemptsSuccess: this.state.callAttemptsSuccess + 1 },
            () => {
              if (this.state.callAttemptsSuccess >= 1) {
                this.setState({ disableCallButton: true });
              }
            }
          );
        }
      } catch (err) {
        if (generateOtpinterval) {
          clearInterval(generateOtpinterval);
        }

        this.setState({
          showGenerateOtpTime: false,
          generateOtpTime: 60,
          disableGenerateOtpButton: false,
        });
        if (this.state.callAttemptsSuccess >= 1) {
          this.setState({
            showCallTime: false,
            callOtpTime: 60,
            disableCallButton: false,
          });
        }

        this.handleSnackbar(true, "error", "Please try again");
      } finally {
        this.props.showLoader(false);
        this.setState({
          generatingOtp: false,
          otpButtonText: "Regenerate OTP",
        });
        if (
          this.state.callAttemptsSuccess >= 1 &&
          this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED
        ) {
          this.setState({ attemptErrorMsg: "Please wait for some time." });
        }
        setTimeout(() => {
          if (
            this.state.callAttemptsSuccess >= 1 &&
            this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED
          ) {
            this.setState({
              attemptErrorMsg:
                "You have exceeded all your attempts to receive OTP, please contact the helpdesk No. 1800 121 8143/ 1800 102 8672",
            });
          }
        }, 20000);
      }
    });
  };

  handleCheckbox = (value) => {
    this.setState({ checkboxValue: value });
  };

  checkMergeChunkStatus = async () => {
    const { url } = getApiData("verifyVideoStatus");
    this.setState({ submitting: true });
    const { posvRefNumber } = this.state;
    const body = {
      posvRefNumber
    }
    const token = sessionStorage.getItem('mt')
    try {
      const response = await Axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      if (response.data.response.msgInfo.msgCode === "200") {
        this.setState({ submitting: false });
        this.submit()
      } else if (response.data.response.msgInfo.msgCode === "203") {
        console.log("In Progess")
        const { mergeStatusRetry } = this.state
        if (mergeStatusRetry) {
          this.setState({ showMergeChunkErrDialog: true, submitting: false })
        } else {
          this.setState({ mergeStatusRetry: true })
          setTimeout(() => {
            this.checkMergeChunkStatus()
          }, 2000)
        }
      } else {
        this.setState({ showMergeChunkErrDialog: true, submitting: false })
      }
    } catch (err) {
      this.setState({ showMergeChunkErrDialog: true, submitting: false })
    }
  }

  handleOtpSubmit = () => {
    const { isVideoPosv } = this.state
    const isProposerJourney = localStorage.getItem("journeyBy") === "P"
    if (isVideoPosv === "Y" && !isProposerJourney) {
      this.checkMergeChunkStatus()
    } else {
      this.submit()
    }
  }

  submit = async () => {
    this.props.showLoader(true);
    this.setState({ submitting: true });
    if (this.state.channelName === "x") {
      this.SubmitOtp();
    } else {
      const { url, body } = getApiData("declaration");
      body.request.payload.customerDisclaimer = "Agreed";
      try {
        await axios.post(url, body);
        this.SubmitOtp();
      } catch (err) {
        this.props.showLoader(false);
        this.setState({ submitting: false });
        this.handleSnackbar(
          true,
          "error",
          "Something went wrong. Please try again"
        );
      }
    }
  };

  SubmitOtp = async () => {
    const { journeyBy, isVideoPosv, hasAudioFlag, verificationSource, showGoGreenSection, goGreenFlag, getAlertsCheckbox, declarationObj, isUpfrontPaymentConsentChecked } = this.state;
    const inps = document.getElementsByClassName("input_otp");
    let otp = "";
    for (let inp of inps) {
      otp += inp.value;
    }
    const { url, body } = getApiData("validateOtp");
    const isUpfrontPaymentConsentRequired = localStorage.getItem("upfrontPaymentConsent") === CAPS_Y;

    body.request.payload.otp = otp;
    body.request.payload.isRegularUpdate = getAlertsCheckbox;
    body.request.payload.cisConsentOnOtp = this.state.cisConsentOnOtp["english"];

    if (isUpfrontPaymentConsentRequired && isUpfrontPaymentConsentChecked) {
      body.request.payload.upfrontPaymentConsentOnOtp = getOTPDeclarationFromStorage(DECLRATION_IDS.UPFRONT_PAYMENT_CONSENT)["english"]
    }
    if (journeyBy == "P") {
      body.request.payload.clubbeOtpDetails = this.state.clubbeOtpDetails;
    }
    if (showGoGreenSection === "Y") {
      body.request.payload.goGreen = goGreenFlag
    }
    try {
      const response = await axios.post(url, body);
      console.log("response", response);
      const { submissionRestricted, businessMsg, isPolicyInactive } =
        response.data.response.payload;


      if (isPolicyInactive === true) {
        localStorage.setItem('showNewUI','Y')
        if (businessMsg) {
          sessionStorage.setItem("expiredBusinessMsg", businessMsg);
        }
        this.setState({
          businessMsg: businessMsg || "Your link has been expired, kindly connect with seller"
        });
        this.props.history.push('/blocked_journey?s=pi');
        return;
      }
      if (submissionRestricted === "Y") {
        this.setState({
          submissionRestricted: "Y",
          businessMsg,
        });
        return;
      }
      if (response.data.response.messageInfo.msgCode === "700") {
        this.setState({ submitting: false });
        this.handleSnackbar(
          true,
          "error",
          response.data.response.payload.businessMsg
        );
        return;
      }
      document.removeEventListener("keyup", this.inputFunction);
      this.setState({ submitting: false });
      this.props.history.push("/thankyou");
    } catch (err) {
      this.setState({ submitting: false });
      this.handleSnackbar(
        true,
        "error",
        "Something went wrong. Please check otp and try again"
      );
    } finally {
      this.props.showLoader(false);
    }
  };

  handleSnackbar = (showSnackbar, snackbarMsgType, snackbarMsg) => {
    this.setState({ showSnackbar, snackbarMsgType, snackbarMsg });
    setTimeout(() => {
      this.closeSnackbar();
    }, 2500);
  };

  getSteps = () => {
    if (this.state.isNps == "Y" || this.state.journeyBy == "P") {
      return isNpsSteps;
    } else if (this.state.isVideoPosv == "Y") {
      return hybridPosvSteps;
    } else if (this.state.twoStep == "Y") {
      return QCSteps;
    } else {
      return photoVerificationSteps;
    }
  };

  closeSnackbar = () => {
    this.setState({
      showSnackbar: false,
      snackbarMsgType: "",
      snackbarMsg: "",
    });
  };

  handleClubbedOtpSubmit = async (clubbeOtpDetails) => {
    this.setState({ clubbeOtpDetails });
    this.setState({ showClubbedOtpPage: false });
    this.generateOtp("generate");
  };

  getTextForDisplay = (declaration, isReadMore) => {
    return isReadMore ? declaration : declaration.slice(0, 150)
  }

  validateSubmitButton = () => {
    const {
      aadharCheckbox,
      customerConsentAfyp,
      isPanAadharLinked,
      submitting,
      disableSubmitButton,
      checkboxValue,
      showOTPPage,
    } = this.state;
    const { showDeclaration } = this.state.declarationObj;
    if (
      (customerConsentAfyp == "Y" || isPanAadharLinked == "N") &&
      !aadharCheckbox
    ) {
      return false;
    }

    if (submitting || disableSubmitButton) {
      return false;
    }

    if (showDeclaration && showOTPPage !== "Y" && !checkboxValue) {
      return false;
    }

    return true;
  };

  handleGoGreenCheckbox = (e) => {
    let value = e.target.checked ? 'Y' : 'N';
    this.setState({ goGreenFlag: value })
  }

  handleReadMore = () => {
    this.setState({ readMoreDisclaimer: !this.state.readMoreDisclaimer });
  };

  getPanLinkedDisclaimer = () => {
    const { readMoreDisclaimer } = this.state;
    const PAN_LINK_DISCLAIMER = getOTPDeclarationFromStorage(DECLRATION_IDS.IS_PAN_AADHAR_LINKED)[getUserLang()];

    return (
      <div className="disclaimer-text-pan">
        <p className="disclaimer-heading-pan">{this.props.t("Disclaimer")}:</p>
        <p>
          {readMoreDisclaimer
            ? PAN_LINK_DISCLAIMER
            : PAN_LINK_DISCLAIMER.slice(0, 150)}{readMoreDisclaimer ? '' : "..."}
          <span className="read-more-pan" onClick={this.handleReadMore}>
            {readMoreDisclaimer ? this.props.t("Read less") : this.props.t("Read more")}
          </span>
        </p>
        {/* {PAN_LINK_DISCLAIMER.length > 150 && ( */}
        {/* )} */}
      </div>
    )
  };

  render() {
    const {
      submissionRestricted,
      attemptErrorMsg,
      businessMsg,
      showSnackbar,
      showOTPPage,
      displayMessage,
      submitting,
      showCallButton,
      disableGenerateOtpButton,
      showGenerateOtpTime,
      otpButtonText,
      snackbarMsgType,
      snackbarMsg,
      generateOtpTime,
      disableCallButton,
      showCallTime,
      callOtpTime,
      disableSubmitButton,
      showClubbedOtpPage,
      isWipClubbed,
      isPanAadharLinked,
      customerConsentAfyp,
      goGreenFlag,
      showGoGreenSection,
      showMergeChunkErrDialog,
      getAlertsCheckbox,
      isPanLinked,
      isUpfrontPaymentConsentChecked,
      isUpfrontPaymentConsentApplicable,
      isReadmoreUpfront
    } = this.state;
    const { showDeclaration, declaration } = this.state.declarationObj;
    return (
      <>
        {showMergeChunkErrDialog && <MergeChunkErrorDialog />}
        {submissionRestricted === "Y" ? (
          <Error errorMsg={this.props.t(`${businessMsg}`)} />
        ) : showClubbedOtpPage && isWipClubbed == "Y" ? (
          <ClubbedOtp submitHandler={this.handleClubbedOtpSubmit} />
        ) : (
          <div className="generateOtp-container old-otp">
            <HeadStepper
              activeState={this.getSteps().length}
              allSteps={this.getSteps()}
            />
            <div className="alrt-msg">
              {showSnackbar ? (
                <Snackbar
                  closeSnackbar={this.closeSnackbar}
                  snackbarMsgType={snackbarMsgType}
                  snackbarMsg={this.props.t(`${snackbarMsg}`)}
                />
              ) : null}
            </div>

            {showOTPPage !== "Y" ? (
              <div className="dsclmr-wrap">
                <div className="generate-otp__grid">
                  <div>
                    {/* <img src={otp_top_img} alt="Cell Phone" /> */}
                    <p className="head_text">
                      {this.props.t(`${displayMessage}`)}
                    </p>
                    <p className="small-txt">
                      {this.props.t(`${attemptErrorMsg}`)}
                    </p>
                    {/* <p className="default_text">
                  {this.props.t(`${this.state.displayMessage}`)}
                </p> */}
                    {/* <h4 className="default_text">{this.props.t("4digitcode")}</h4> */}
                  </div>

                  <div className="otpandBtn">
                    <div
                      className="otpImport"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <OtpOld submitting={submitting} />
                    </div>
                    <div className="buttons_div__otp">
                      <div className="btn-time">
                        {/* <Button
                    variant="contained"
                    disabled={
                      submitting ||
                      disableGenerateOtpButton
                    }
                    className="default_button"
                    onClick={() => this.generateOtp("generate")}
                  >
                    {this.props.t(`${this.state.otpButtonText}`)}
                  </Button> */}

                        <button
                          disabled={submitting || disableGenerateOtpButton}
                          className="generateOtp_text"
                          onClick={() => this.generateOtp("generate")}
                        >
                          {showGenerateOtpTime ? (
                            <span className="otpTime">
                              Didn’t receive OTP?{" "}
                              <span>Resend in {generateOtpTime}</span>
                            </span>
                          ) : (
                            this.props.t(`${otpButtonText}`)
                          )}
                        </button>
                        {/* {this.state.showGenerateOtpTime ? (
                    <span className="otpTime">
                      {this.state.generateOtpTime}
                    </span>
                  ) : null} */}
                      </div>

                      {showCallButton ? (
                        <div className="btn-time">
                          {/* <Button
                      variant="contained"
                      disabled={
                        this.state.submitting || this.state.disableCallButton
                      }
                      className="default_button"
                      id="call_button"
                      onClick={() => this.generateOtp("call")}
                    >
                      {this.props.t("otponcall")}
                    </Button> */}

                          <button
                            disabled={submitting || disableCallButton}
                            style={{ textAlign: "right" }}
                            className="generateOtp_text"
                            id="call_button"
                            onClick={() => this.generateOtp("call")}
                          >
                            {showCallTime ? (
                              <span className="otpTime">
                                Didn’t receive OTP?{" "}
                                <span>Resend in {callOtpTime}</span>
                              </span>
                            ) : (
                              this.props.t("otponcall")
                            )}
                          </button>

                          {/* {this.state.showCallTime ? (
                      <span className="otpTime">{this.state.callOtpTime}</span>
                    ) : null} */}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                {isPanLinked === "N" && this.getPanLinkedDisclaimer()}
                {showGoGreenSection === "Y" && <GoGreenSection goGreenFlag={goGreenFlag} handleGoGreenCheckbox={this.handleGoGreenCheckbox} />}

                {showDeclaration ? (
                  <>
                    <div className="tnc-txt">
                      <form>
                        <fieldset>
                          <label className="generateotp-checkobox">
                            <input
                              disabled={this.state.submitting}
                              type="checkbox"
                              value={this.state.checkboxValue}
                              onChange={(event) =>
                                this.handleCheckbox(event.target.checked)
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <p className="check-sec">
                            {" "}
                            {this.props.t(`${declaration}`)}
                          </p>
                        </fieldset>
                        {(customerConsentAfyp == "Y" ||
                          isPanAadharLinked == "N") && (
                            <fieldset>
                              <label className="generateotp-checkobox">
                                <input
                                  disabled={this.state.submitting}
                                  type="checkbox"
                                  value={this.state.aadharCheckbox}
                                  onChange={(event) =>
                                    this.setState({
                                      aadharCheckbox: event.target.checked,
                                    })
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                              <p className="check-sec addhar-dec">
                                {" "}
                                {/* {this.props.t(
                                  "pan_addhar_declaration"
                                )} */}
                                {getOTPDeclarationFromStorage(DECLRATION_IDS.PAN_ADDHAR_DECLARATION)[getUserLang()]}
                                <span
                                  onClick={this.readMoreText}
                                  className="read_more_otp_dec"
                                >
                                  {" "}
                                </span>
                              </p>
                            </fieldset>
                          )}
                        <fieldset className="sec-declaration">
                          <label className="generateotp-checkobox">
                            <input
                              disabled={this.state.submitting}
                              type="checkbox"
                              value={getAlertsCheckbox}
                              checked={getAlertsCheckbox === CAPS_Y}
                              onChange={(event) =>
                                this.setState({
                                  getAlertsCheckbox: (event.target.checked ? CAPS_Y : CAPS_N),
                                })
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <p className="check-sec">
                            {/* {this.props.t(regularAlertsDiscalimer)} */}
                            {getOTPDeclarationFromStorage(DECLRATION_IDS.REGULAR_OTP_DISCLAIMER)[getUserLang()]}
                          </p>
                        </fieldset>
                        {isUpfrontPaymentConsentApplicable && <fieldset className="sec-declaration">
                          <label className="generateotp-checkobox">
                            <input
                              disabled={this.state.submitting}
                              type="checkbox"
                              value={isUpfrontPaymentConsentChecked}
                              checked={isUpfrontPaymentConsentChecked}
                              onChange={(event) =>
                                this.setState({
                                  isUpfrontPaymentConsentChecked: event.target.checked,
                                })
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <p className="check-sec">
                            {this.getTextForDisplay(getOTPDeclarationFromStorage(DECLRATION_IDS.UPFRONT_PAYMENT_CONSENT)[getUserLang()], isReadmoreUpfront)}
                            <span className="read_more_otp_dec" onClick={() => this.setState({ isReadmoreUpfront: !isReadmoreUpfront })}>
                              {isReadmoreUpfront ? this.props.t("Read less") : this.props.t("Read more")}
                            </span>
                          </p>
                        </fieldset>}
                      </form>
                    </div>
                  </>
                ) : (
                  <>
                    <Button
                      style={{ justifyContent: "center", display: "flex" }}
                      variant="contained"
                      className="default_button submit_button--generate_otp"
                      onClick={this.handleOtpSubmit}
                      disabled={!this.validateSubmitButton()}
                    // disabled={
                    //     submitting || disableSubmitButton
                    // }
                    >
                      {this.props.t("Submit")}
                    </Button>
                  </>
                )}
              </div>
            ) : (
              <Error errorMsg={this.state.errorMsg} />
            )}
            {showDeclaration && this.state.showOTPPage !== "Y" ? (
              <div className="gen-otp-btn-cntnr">
                <button
                  className="default_button submit_button--generate_otp"
                  onClick={this.handleOtpSubmit}
                  disabled={!this.validateSubmitButton()}
                // disabled={
                //     this.state.submitting ||
                //     this.state.disableSubmitButton ||
                //     !this.state.checkboxValue
                // }
                >
                  {this.props.t("Submit")} →
                </button>
              </div>
            ) : null}
          </div>
        )}
      </>
    );
  }
}

export default compose(
  withRouter,
  connect(null, { showLoader }),
  withTranslation()
)(GenerateOtpOld);
